import packageJson from "../../package.json";
const useMetadata = () => {
    const { proxy } = packageJson;
    return {
        proxy,
    };
};

export default useMetadata;
